export default {
  computed: {
    token() {
      return this.$store.state.user.token;
    },

    member() {
      return this.$store.state.user.member;
    },

    wishlists() {
      return this.$store.state.user.wishlists;
    },

    comparison() {
      return this.$store.state.user.comparison;
    },

    rates() {
      return this.$store.state.user.rates;
    },
  },
};
